import {SuggestAction, SuggestObjectAction} from '../../../model/suggest'
import type {
  FinalizeSuggestBody,
  SuggestBody,
  SuggestState,
  UserInputSuggestBody,
  ZeroSuggestBody,
} from '../../../repo/suggest/types'
import type {AddressSuggestParams} from '../type'

/**
 * state: {location: [lon, lat]}
 * точка относительно которой будет посчитана дистанция
 * для точки А это координаты, с которыми инициализировали приложение
 * для точки Б это координаты точки А, и так далее
 */

const getState = (params: AddressSuggestParams): SuggestState => ({
  location: params.location,
  accuracy: 0,
  current_mode: 'delivery_b2b',
})

const toUserSelectSuggestBody = (params: AddressSuggestParams): UserInputSuggestBody => ({
  type: params.type,
  action: 'user_select',
  state: getState(params),
  part: params.__origin?.text,
  prev_log: params.__origin?.log,
})

const toFinalizeSuggestBody = (params: AddressSuggestParams): FinalizeSuggestBody => ({
  type: params.type,
  action: 'finalize',
  state: getState(params),
  position: params.__origin?.position,
  prev_log: params.__origin?.log,
  sticky: true,
})

const toZeroSuggestBody = (params: AddressSuggestParams): ZeroSuggestBody => ({
  type: params.type,
  action: 'zero_suggest',
  position: params.point || params.location,
  state: getState(params),
})

const toUserInputSuggestBody = (params: AddressSuggestParams): UserInputSuggestBody => ({
  type: params.type,
  part: params.text,
  action: 'user_input',
  state: getState(params),
})

const toPinDropSuggestBody = (params: AddressSuggestParams): FinalizeSuggestBody => ({
  type: params.type,
  position: params.point,
  entrance: params.__origin?.porchnumber,
  action: 'pin_drop',
  state: getState(params),
  sticky: false,
})

const toGeomagnetSuggestBody = (params: AddressSuggestParams): FinalizeSuggestBody => ({
  type: params.type,
  entrance: params.entrance,
  position: params.location,
  action: 'geomagnet',
  state: getState(params),
  sticky: true,
  prev_log: params.log,
})

export const toSuggestBody = (params: AddressSuggestParams): SuggestBody => {
  if (params.action === SuggestAction.PIN_DROP) {
    return toPinDropSuggestBody(params)
  }

  if (params.action === SuggestAction.GEO_MAGNET) {
    return toGeomagnetSuggestBody(params)
  }

  if (params.__origin) {
    if (params.__origin.action === SuggestObjectAction.SUBSTITUTE) {
      return toUserSelectSuggestBody(params)
    }

    return toFinalizeSuggestBody(params)
  }

  if (typeof params.text === 'string') {
    return toUserInputSuggestBody(params)
  }

  return toZeroSuggestBody(params)
}
